import React, { Component } from 'react';
import { MDBContainer, MDBRow, MDBCol } from 'mdbreact';
import './Title.scss';
import { Styledtd } from './homePageStyled.js';

// const getSummary = () => {
//   // beginDate, lastDate
//   let beginDate = new Date();
//   let lastDate = new Date();
//   beginDate.setFullYear(2018, 12, 2);
//   lastDate.setFullYear(2019, 3, 5);
//
//   fetch(`${global.gConfig.backend.url}/medicamproduction/statistics?_beginDate=${beginDate.toUTCString()}&_lastDate=lastDate=${lastDate.toUTCString()}`)
//     .then( res => res.json())
//     .then( products => {
//       let statusArray = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
//       products.map((value, index) => {
//         <div>{value}</div>
//       })
//     })
//     .catch( err => {console.log(err)})
// }

class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statusArray: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      statusIndex: ['--', 'Factory(NG)', 'Factory(OK)', 'Engineering', 'In stock', 'Shipped', 'R&D(NK)', 'Lab', 'Demo', 'RMA'],
      statusArrayThisMonth: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      viewersNum: 0,
      publishersNum: 0
    };
  }

  componentDidMount() {
    let beginDate = new Date();
    let lastDate = new Date();
    beginDate.setFullYear(2019, 1, 1);

    var date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    this.fetchMedicamProductionSummary(beginDate, lastDate, (statusArray) => {this.setState({statusArray: statusArray})});
    this.fetchMedicamProductionSummary(firstDay, firstDay, (statusArray) => {this.setState({statusArrayThisMonth: statusArray})});
    this.fetchLiveClientsSummary((viewersNum) => {this.setState({viewersNum: viewersNum})});
    this.fetchLiveStreamsSummary((publishersNum) => {this.setState({publishersNum: publishersNum})});
  }

  fetchMedicamProductionSummary (beginDate, lastDate, callback) {
    fetch(`${global.gConfig.backend.url}/medicamproduction/statistics?_beginDate=${beginDate.toUTCString()}&_lastDate=lastDate=${lastDate.toUTCString()}`)
      .then( res => res.json())
      .then( summaryArray => {
        let statusArray= [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        summaryArray.map((value, index) => {
          statusArray[Number(value._id)] += value.total;
        })
        return statusArray;
      })
      .then((results) => {
        callback(results);
      })
      .catch( err => {console.log(err)})
  }

  fetchLiveClientsSummary (callback) {
    fetch(`${global.gConfig.backend.url}/api/v1/clientsSummary`)
      .then( res => res.json())
      .then( viewersNum => {
        return viewersNum
      })
      .then((results) => {
        callback(results);
      })
      .catch( err => {console.log(err)})
  }

  fetchLiveStreamsSummary (callback) {
    fetch(`${global.gConfig.backend.url}/api/v1/streamsSummary`)
      .then( res => res.json())
      .then( publishersNum => {
        return publishersNum
      })
      .then((results) => {
        callback(results);
      })
      .catch( err => {console.log(err)})
  }

  render() {
    const { statusIndex, statusArray, statusArrayThisMonth } = this.state;
    return (
      <MDBContainer>
        <h1 className="mx-auto blue-text mb-4">Statistics</h1>
        <MDBRow style={{display: "flex", alignItems: "stretch"}}>
          <MDBCol className="column-1" style={{marginBottom: "1rem"}}>
            <blockquote className="blockquote bq-primary z-depth-1 h-100 ">
              <p className="bq-title">All</p>
              <table className="list-unstyled">
                <tbody>
                  {statusIndex.map((value, index) => {
                    return index ?
                    (<tr key={`counter ${value}`}>
                      <Styledtd className=".ml-1">{`${value}:  `}</Styledtd>
                      <Styledtd>{`${statusArray[index]}`}</Styledtd>
                    </tr>) : null})}
                </tbody>
              </table>
            </blockquote>
          </MDBCol>
          <MDBCol className="column-1" style={{marginBottom: "1rem"}}>
            <blockquote className="blockquote bq-primary z-depth-1 h-100">
              <p className="bq-title">This Month</p>
              <table className="list-unstyled">
                <tbody>
                  {statusIndex.map((value, index) => {
                    return index ?
                    (<tr key={`counter ${value}`}>
                      <Styledtd>{`${value}:  `}</Styledtd>
                      <Styledtd>{`${statusArrayThisMonth[index]}`}</Styledtd>
                    </tr>) : null})}
                </tbody>
              </table>
            </blockquote>
          </MDBCol>
          <MDBCol className="column-1" style={{marginBottom: "1rem"}}>
            <blockquote className="blockquote bq-primary z-depth-1 h-100">
              <p className="bq-title blue-text">Live</p>
              <table>
                <tbody>
                  <tr>
                    <Styledtd>{`Viewers:  `}</Styledtd><Styledtd>{`${this.state.viewersNum}`}</Styledtd>
                  </tr>
                  <tr>
                    <Styledtd>{`Publishers:  `}</Styledtd><Styledtd>{`${this.state.publishersNum}`}</Styledtd>
                  </tr>
                </tbody>
              </table>
            </blockquote>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    );
  }
}


export default HomePage;
